<template>
    <div class="edit-user">

        <div class="card">
            <div class="card-header">
                <h5 class="card-title text-center" >Create Admin</h5>
                <hr>
            </div>
            <div class="card-body">
                <div class="row mb-2">
                    <BasicTextInput label="First Name"
                                    v-model="user.FirstName"
                                    :validator="$v.user.FirstName"
                                    :validatorMsgMap="validatorMsgMapBase"
                                    class="col-6" />
                    <BasicTextInput label="Last Name"
                                    v-model="user.LastName"
                                    :validator="$v.user.LastName"
                                    :validatorMsgMap="validatorMsgMapBase"
                                    class="col-6" />
                </div>

                <div class="row mb-2">
                    <PhoneNumberInput label="Phone" class="col-6" v-model="user.MobilePhone" />
                    <BasicTextInput   label="Email"
                                      class="col-6"
                                      :validator="$v.user.Email"
                                      :validatorMsgMap="validatorMsgMapBase"
                                      v-model="user.Email"       />
                </div>

                <div class="mt-4">
                    <button class="btn btn-primary btn-block" @click="createAdmin">Create Admin</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { AdminUserService }        from '@/services';
    import { validatorMsgMapBase } from "@/modules/helpers";
    import {
        required,
        email,
    }                              from 'vuelidate/lib/validators';

    export default {
        name: "AdminUsersEdit",
        data: () => {
            return {
                validatorMsgMapBase: validatorMsgMapBase,
            }
        },
        props: {
            user: {
                type: Object,
                default: () => {
                    return {
                        FirstName: '',
                        LastName:  '',
                        MobilePhone: '',
                        Email: '',
                    }
                }
            },
            users: {
                type: Array,
            }
        },
        validations: {
            user: {
                FirstName: {
                    required,
                },
                LastName: {
                    required,
                },
                Email: {
                    required,
                    email,
                }
            },
        },
        methods: {
            createAdmin(){
                this.$v.user.$touch();
                if (this.$v.user.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }

                AdminUserService.create(this.user).then(res => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Admin Created', type: 'success'});
                    this.$emit('update:success');
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error'});
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .edit-user {
        min-width: 600px;
    }
</style>

